import React, { useState, useEffect, useRef } from 'react';
import CustomTitle from '../../components/UI/title/CustomTitle';
import MyButton from '../../components/UI/button/MyButton';
import { WithWizard } from 'react-albus-react18';
import './signup.scss';
import CustomCheckbox from '../../components/UI/chekbox/CustomCheckbox';
import Term from '../Term';
import Privacy from '../Privacy';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import { useGetInfoQuery, useLoginMutation } from '../../api/dataApi';
import useFaceBook from '../../hooks/useFaceBook';
import useMixpanel from '../../hooks/useMixpanel';
import { useDispatch } from 'react-redux';
import { setButtonClick } from '../../store/buttonSlice';
import LoginToEmail from './components/LoginToEmail';

import { setBlockClassName } from '../../store/blockClassNameSlice';

const Signup2 = ({ setWelcomeWrapper, setWhiteWrapper, setWelcometo, setShowBrandName, setShowWebSite, termChange, privacyChange, setLoginChangeStatus, setSelectedOption, setButtonShow, setBlockPaddingBottom, setSignupBottom, signupBottom, buttonStatus, setButtonStatus, forgetPassword, setEventProperties, sessionId, setEventName }) => {
    const history = useHistory();
    const queryParams = new URLSearchParams(history.location.search);
    const [loginMutation, { isLoading: isLoginLoading, error: loginError }] = useLoginMutation();
    const [error, setError] = useState(false);
    const { trackP1Event } = useMixpanel();
    const dispatch = useDispatch();
    const urlParams = new URLSearchParams(window.location.search);

    useEffect(() => {
        dispatch(setBlockClassName(""));
        setWelcomeWrapper(false)
        setWhiteWrapper(false)
        setWelcometo(false)
        setButtonText('Continue');
        setButtonShow(false);
        setLoginChangeStatus(true)
        setSignupBottom('checkbox');
        setButtonStatus('checkEmail');
        setSelectedOption('1')
        setShowBrandName(false)
        setShowWebSite(false)
        setBlockPaddingBottom('32rem')
        mixpanel.track('web_signup_2', {
            session_id: sessionId,
            web_utm_campaign: urlParams.get("utm_campaign"),
            web_utm_source: urlParams.get("utm_source"),
            web_utm_medium: urlParams.get("utm_medium"),
            web_utm_content: urlParams.get("utm_content"),
            web_utm_term: urlParams.get("utm_term"),
            isDebug: false,
            funnel: process.env.REACT_APP_FUNNEL,
        });
    }, []);


    const { data, refetch } = useGetInfoQuery();
    const [pageComponent, setPageComponent] = useState('checkEmail');
    const [inputEmail, setInputEmail] = useState('');
    const [inputPassword, setInputPassword] = useState('');
    const [msgPassword, setMsgPassword] = useState('');
    const [inputPassword2, setInputPassword2] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [code, setCode] = useState(Array(6).fill(''));
    const { sendFb } = useFaceBook();

    useEffect(() => {
        sendFb("ViewContent", {});
    }, [])

    const [userNotFound, setUserNotFound] = useState(false);

    const logIn = async (ResetPassword) => {
        try {
            const data = {
                email: inputEmail,
                password: inputPassword,
                os: 'web',
                withAuth: true
            };
            const response = await loginMutation(data).unwrap();
            setButtonStatus('');
            if (response.data.statusCode === 400 && response.data.message === 'Password is wrong') {
                setError(true);
                setMsgPassword('Sorry, you entered the wrong password. Please try again.')
                setTimeout(() => {
                    setMsgPassword('')
                    setError(false);
                }, 1000);
            } else {
                localStorage.setItem("accessToken", response.data.accessToken);
                localStorage.setItem('authToken', response.data.authToken);
                localStorage.setItem('email', inputEmail);
                localStorage.setItem('signupMethod', 'Login');
                if (ResetPassword) {
                    trackP1Event('web_signin_success', {})
                }
                refetch()
                businessProfiles()
                sendUtm()
                sendData()
                checkSubscribe()
                // history.push('/name');
            }
        } catch (err) {
            setError(true);
            console.log(err.data.message);
            if (err?.data?.message === 'User not found') {
                setUserNotFound(true);
            } else {
                setUserNotFound(false);
                setMsgPassword('Sorry, you entered the wrong password. Please try again.')
                setTimeout(() => {
                    setMsgPassword('');
                }, 1000);
            }

            setTimeout(() => {
                setError(false);
            }, 1000);
            setButtonStatus('');
        }
    };




    const checkSubscribe = () => {

        axios.get("https://staging.zeely.link/subscriptions/current", {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            },
            redirect: 'follow'
        })
            .then(response => {
                console.log(response.data.data.status)
                if (response.data.data.status === 'ACTIVE' || response.data.data.status === 'REDEMPTION') {
                    localStorage.setItem('subscriptionsStatus', 'paid')
                    localStorage.setItem('userId', response.data.data.userId)
                    trackP1Event('web_loggedIn', {
                        web_entrance: 'login',
                    })

                    if (response?.data.data?.bundleStatus === 'ACTIVE') {
                        history.push({
                            pathname: '/thankyou',
                            search: `?${queryParams.toString()}`,
                        });

                    } else {
                        history.push({
                            pathname: '/loader',
                            search: `?${queryParams.toString()}`,
                        });

                    }
                } else {
                    localStorage.setItem('subscriptionsStatus', 'free')
                    checkName()
                }
            })
            .catch(error => {
                checkName()
            });
    }

    const checkName = () => {
        axios.get("https://staging.zeely.link/users", {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            },
            redirect: 'follow'
        })
            .then(response => {
                localStorage.setItem('userId', response.data.data.id)
                trackP1Event('web_loggedIn', {
                    web_entrance: 'login',
                })
                if (response.data.data.name && response.data.data.name.length) {

                    if (localStorage.getItem('checkEmailLInk')) {
                        setButtonStatus("");
                        setSignupBottom('');
                        history.push(localStorage.getItem('checkEmailLInk'));
                    } else {
                        history.push({
                            pathname: '/signin_success',
                            search: `?${queryParams.toString()}`,
                        });
                    }
                } else {
                    if (localStorage.getItem('checkEmailLInk')) {
                        setButtonStatus("");
                        setSignupBottom('');
                        history.push(localStorage.getItem('checkEmailLInk'));
                    } else {
                        history.push({
                            pathname: '/signin_success',
                            search: `?${queryParams.toString()}`,
                        });
                    }
                }
            })
            .catch(error => {
                // history.push('/name');
            });
    }

    const signUp = () => {
        const data = {
            email: inputEmail,
            password: inputPassword,
            os: 'web',
            withAuth: true
        };

        axios.post("https://staging.zeely.link/users/register", data, {
            headers: {
                "Content-Type": "application/json"
            },
            redirect: 'follow'
        })
            .then(response => {
                console.log(response)
                if (response.data.statusCode === 400 && response.data.message === 'User already exist') {
                    setButtonStatus('signUp');
                } else {
                    const urlParams = new URLSearchParams(window.location.search);
                    mixpanel.track('web_signup_confirm', {
                        session_id: sessionId,
                        web_entrance: "signup",
                        web_utm_campaign: urlParams.get("utm_campaign"),
                        web_utm_source: urlParams.get("utm_source"),
                        web_utm_medium: urlParams.get("utm_medium"),
                        web_utm_content: urlParams.get("utm_content"),
                        web_utm_term: urlParams.get("utm_term"),
                        isDebug: false,
                        funnel: process.env.REACT_APP_FUNNEL,

                    });
                    localStorage.setItem("accessToken", response.data.data.accessToken);
                    localStorage.setItem('authToken', response.data.data.authToken);
                    localStorage.setItem('email', inputEmail);
                    refetch()
                    businessProfiles();
                    sendUtm()
                    sendData()
                    axios.get("https://staging.zeely.link/users", {
                        headers: {
                            "Content-Type": "application/json",
                            'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
                        },
                        redirect: 'follow'
                    })
                        .then(response => {
                            localStorage.setItem('userId', response.data.data.id)
                            history.push({
                                pathname: '/name',
                                search: `?${queryParams.toString()}`,
                            });
                        })
                        .catch(error => {
                            // history.push('/name');
                        });
                    // history.push('/name');
                }
            })
            .catch(error => {
                setButtonStatus('signUp');
            });
    };


    const signupUrlParams = new URLSearchParams(window.location.search);
    const utmSource = signupUrlParams.get("utm_source") || mixpanel.get_property("utm_source") || '';
    const utmMedium = signupUrlParams.get("utm_medium") || mixpanel.get_property("utm_medium") || '';
    const utmCampaign = signupUrlParams.get("utm_campaign") || mixpanel.get_property("utm_campaign") || '';
    const utmContent = signupUrlParams.get("utm_content") || mixpanel.get_property("utm_content") || '';
    const utmTerm = signupUrlParams.get("utm_term") || mixpanel.get_property("utm_term") || '';

    const sendData = async () => {
        const formdata = new FormData();
        formdata.append("domen", window.location.hostname + process.env.REACT_APP_BASENAME);
        formdata.append("email", inputEmail);
        formdata.append("utmSource", utmSource);
        formdata.append("utmMedium", utmMedium);
        formdata.append("utmCampaign", utmCampaign);
        formdata.append("utmContent", utmContent);
        formdata.append("utmTerm", utmTerm);
        try {
            const response = await axios.post("https://zee.sale/send-1-ai.php", formdata, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log(response.data);
        } catch (error) {
            console.error(error);
        }
    };


    const sendUtm = () => {
        const data = {
            "utmSource": urlParams.get("utm_source") || "default_source",
            "utmMedium": urlParams.get("utm_medium") || "default_medium",
            "utmCampaign": urlParams.get("utm_campaign") || "default_campaign",
            "utmTerm": urlParams.get("utm_term") || "default_term",
            "utmContent": urlParams.get("utm_content") || "default_content",
            "url": window.location.hostname
        };
        axios.post("https://staging.zeely.link/users/utm", data, {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            },
            redirect: 'follow'
        })
            .then(response => {
                console.log(response)

            })
            .catch(error => {
                console.log(error)
            });
    }

    const businessProfiles = () => {

        var profilesJSON = localStorage.getItem('business-profiles');
        if (profilesJSON) {
            var profiles = JSON.parse(profilesJSON);
            profiles.forEach(function (profile) {
                profile.email = inputEmail;
            });
            var updatedProfilesJSON = JSON.stringify(profiles);
            localStorage.setItem('business-profiles', updatedProfilesJSON);
        } else {
            var newProfile = {
                email: inputEmail
            };
            var newProfiles = [newProfile];
            var newProfilesJSON = JSON.stringify(newProfiles);
            localStorage.setItem('business-profiles', newProfilesJSON);
        }

        const fullJSON = localStorage.getItem('business-profiles');
        const profile = JSON.parse(fullJSON)[0];
        const trimmedJSON = JSON.stringify(profile);

        const data = trimmedJSON

        axios.post("https://staging.zeely.link/business-profiles", data, {
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
            },
            redirect: 'follow'
        })
            .then(response => {
                localStorage.setItem('business-profiles-id', response.data.data.id);
            })
            .catch(error => {
                console.log(error)
            });
    };

    const handlePasswordChange = (e) => {
        setInputPassword(e.target.value);
    };

    const handlePassword2Change = (e) => {
        setInputPassword2(e.target.value);
    };


    const handleContinueClick = () => {
        dispatch(setButtonClick(true))
    };


    const [timeLeft, setTimeLeft] = useState(30);

    useEffect(() => {
        if (timeLeft > 0) {
            const timerId = setTimeout(() => {
                setTimeLeft(timeLeft - 1);
            }, 1000);
            return () => clearTimeout(timerId);
        }
    }, [timeLeft]);

    const [buttonText, setButtonText] = useState('');

    useEffect(() => {
        trackP1Event('web_signup_view', {
        })
    }, [])
    return (
        <div style={{ paddingBottom: "0rem" }}>


            <LoginToEmail
                setButtonStatus={setButtonStatus}
                error={error}
                setError={setError}
                inputEmail={inputEmail}
                setPageComponent={setPageComponent}
                showPassword={showPassword}
                inputPassword={inputPassword}
                handlePasswordChange={handlePasswordChange}
                setShowPassword={setShowPassword}
                msgPassword={msgPassword}
                logIn={logIn}
                setMsgPassword={setMsgPassword}
                setButtonText={setButtonText}
                setInputEmail={setInputEmail}
                userNotFound={userNotFound}
                setUserNotFound={setUserNotFound}
                setInputPassword={setInputPassword}

            />



            <MyButton buttonText={buttonText} onClick={handleContinueClick} className={error ? 'error' : ''} buttonStatus={buttonStatus} />

            <div className="block-button">
                <div className="forget"
                    onClick={() => {
                        const params = new URLSearchParams(window.location.search);
                        history.push({
                            pathname: '/signup',
                            search: `?${params.toString()}`,
                        });
                    }}
                    style={{ cursor: "pointer", textDecoration: "underline", }}
                >
                    Sign up with a new email
                </div>
            </div>

        </div >
    );
}
export default Signup2;
